import PropTypes from 'prop-types';

const PricingProfileDateRangeProptype = PropTypes.shape({
  id: PropTypes.number,
  year: PropTypes.number,
  startDate: PropTypes.number,
  endDate: PropTypes.number,
  reason: PropTypes.string,
  corporate: PropTypes.bool,
  createDate: PropTypes.number,
  lastUpdate: PropTypes.number,
});

export default PricingProfileDateRangeProptype;
